import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

const TabIcon = () => {
  if (document.querySelectorAll('.tab-icon-module').length < 1) {
    return;
  }

  const network = document.querySelector('.tab-icon-module .network');

  function createParallaxTimeline(triggerSelector, startYPercent, endYPercent, scaleTo) {
    const tl = gsap.timeline({
        scrollTrigger: {
            trigger: triggerSelector,
            scrub: 1,
            pin: false,
        }
    });

    tl.fromTo(triggerSelector, {
        yPercent: startYPercent,
        scale: 1,
        ease: 'none'
    }, {
        yPercent: endYPercent,
        scale: scaleTo,
        ease: 'none'
    });

    return tl;
  }

  function parallaxEffect() {
    network ? createParallaxTimeline(network, -9, 9, 1) : null;
  }

  parallaxEffect();
};

export default TabIcon;